var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6f8bff",
    d: "M0.876459 0.150368C0.675964 -0.0501228 0.350899 -0.0501227 0.150404 0.150368C-0.0500902 0.350859 -0.0500902 0.675919 0.150404 0.87641L7.77399 8.49986L0.150371 16.1233C-0.0501236 16.3238 -0.0501235 16.6489 0.150371 16.8494C0.350865 17.0499 0.675931 17.0499 0.876425 16.8494L8.50004 9.22591L16.1236 16.8493C16.3241 17.0498 16.6492 17.0498 16.8497 16.8493C17.0502 16.6488 17.0502 16.3238 16.8497 16.1233L9.2261 8.49986L16.8496 0.876463C17.0501 0.675972 17.0501 0.350912 16.8496 0.150421C16.6491 -0.0500701 16.3241 -0.0500701 16.1236 0.150421L8.50004 7.77382L0.876459 0.150368Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueClose);
export default __webpack_public_path__ + "static/media/blueClose.8386c5dc397a77ff9efa15c36b863fa7.svg";
export { ForwardRef as ReactComponent };